import { Input, FormGroup, FormFeedback, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import useSoloLecturaMatriculas from '../../../hooks/useSoloLecturaMatriculas';

const Comentarios = ({ setComentarios, invalidComentarios, setInvalidComentarios }) => {
  const soloLectura = useSoloLecturaMatriculas();

  const handleComentarios = (e) => {
    if (invalidComentarios) {
      setInvalidComentarios(false);
    }

    setComentarios(e.target.value);
  };

  return (
    <Row className="mt-3">
      <h4>Comentarios</h4>
      <FormGroup>
        <Input
          type="textarea"
          name="text"
          id="exampleText"
          className="mb-3"
          onChange={(e) => handleComentarios(e)}
          invalid={invalidComentarios}
          disabled={soloLectura}
        />
        <FormFeedback>Este campo es obligatorio</FormFeedback>
      </FormGroup>
    </Row>
  );
};
Comentarios.propTypes = {
  setComentarios: PropTypes.func,
  invalidComentarios: PropTypes.bool,
  setInvalidComentarios: PropTypes.func,
};
export default Comentarios;
